module.exports = __webpack_public_path__ + "static/media/cakebROOBEE.d910b6ea.png";